// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2NsmM","modalFooterButton":"ModalNotes_modalFooterButton__9ruBs"};